import { render, staticRenderFns } from "./tabsIco.vue?vue&type=template&id=18814416&viewBox=0%200%2010.828%206.414"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports